/* eslint-disable-next-line import/no-extraneous-dependencies -- resolved via tsconfig paths to sibling package source */
import { CreatePasskeyErrorCode } from '@wix/webauthn-management';

export const PASSKEY_ENROLL_KEYS = {
  common: {
    title: 'passkey.postLogin.content.title',
    subtitle: 'passkey.postLogin.content.description',
    learnMore: 'passkeys.postLogin.content.learnMore.cta',
    howItWorksTitle: 'passkeys.postLogin.content.howItWorks.bulletIntro',
    howItWorksItemNoPasswords: 'passkeys.postLogin.content.benefits.itemOne',
    howItWorksItemPhishing: 'passkeys.postLogin.content.benefits.itemTwo',
    howItWorksItemSynced: 'passkeys.postLogin.content.benefits.itemThree',
    passwordFallbackHint: 'passkey.postLogin.content.hint',
    button: 'passkey.postLogin.content.setup.cta',
    skipCta: 'passkeys.postLogin.content.skip.cta',
  },
  success: {
    title: 'passkey.postLogin.success.title',
    subtitle: 'passkey.postLogin.success.description',
    button: 'passkey.postLogin.success.confirm.cta',
  },
  error: {
    general: 'passkey.postLogin.error.generic.message',
    cancelled: 'passkey.postLogin.error.cancelled.message',
    timeout: 'passkey.postLogin.error.timeout.message',
    duplicate: 'passkey.postLogin.error.duplicate.message',
  },
} as const;

const ERROR_KEY_MAP: Partial<Record<CreatePasskeyErrorCode, string>> = {
  [CreatePasskeyErrorCode.GENERAL]: PASSKEY_ENROLL_KEYS.error.general,
  [CreatePasskeyErrorCode.CANCELLED]: PASSKEY_ENROLL_KEYS.error.cancelled,
  [CreatePasskeyErrorCode.TIMEOUT]: PASSKEY_ENROLL_KEYS.error.timeout,
  [CreatePasskeyErrorCode.DUPLICATE_PASSKEY]:
    PASSKEY_ENROLL_KEYS.error.duplicate,
};

export function getPasskeyEnrollErrorKey(
  errorCode: CreatePasskeyErrorCode,
): string {
  return ERROR_KEY_MAP[errorCode] ?? PASSKEY_ENROLL_KEYS.error.general;
}
